var validate = {};

export { validate as __exports };
//# sourceMappingURL=validate.js.map
